export default function ViewToggle({ value, onChange, testid = "view-toggle" }) {
  return (
    <div className="inline-flex items-center gap-0 border border-slate-300" data-testid={testid}>
      {["table", "kanban"].map((v) => (
        <button
          key={v}
          onClick={() => onChange(v)}
          data-testid={`${testid}-${v}`}
          className={`px-4 py-1.5 small-caps text-[11px] transition-colors ${
            value === v ? "bg-[#1F2937] text-white" : "text-slate-600 hover:bg-slate-100"
          }`}
        >
          {v === "table" ? "Spreadsheet" : "Kanban"}
        </button>
      ))}
    </div>
  );
}
